import { useDisclosure } from "@mantine/hooks";
import { useCallback, useState } from "react";

export function useSystemEmailPreviewDisclosure() {
  const [emailTypeId, setEmailTypeId] = useState<string | null>(null);
  const [opened, disclosure] = useDisclosure(false);
  const open = useCallback(
    (id: string) => {
      setEmailTypeId(id);
      disclosure.open();
    },
    [disclosure]
  );
  const close = useCallback(() => {
    disclosure.close();
    setEmailTypeId(null);
  }, [disclosure]);
  return { emailTypeId, opened, open, close };
}
